import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront';
import { CartImportSelectionComponent } from './components/cart-import-selection/cart-import-selection.component';

export const defaultCartImportSelectionLayoutConfig: LayoutConfig = {
    launch: {
       CART_IMPORT_SELECTION: {
          inlineRoot: true,
          component: CartImportSelectionComponent,
          dialogType: DIALOG_TYPE.DIALOG,
       },
    },
};